export const checkBar = type => {
  try {
    const visible = {
      locationBar: window.locationbar?.visible,
      menuBar: window.menubar?.visible,
      personalBar: window.personalbar?.visible,
      statusBar: window.statusbar?.visible,
      toolBar: window.toolbar?.visible,
    }[type];
    return visible ?? false;
  } catch {
    return false;
  }
};
